import type { ReactNode } from 'react';

export const symbol_google_wifi: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M164-540h632l-11.74-200H176l-12 200Zm-19 290h670l-15-230H160l-15 230Zm53 90-11-30h-43q-25.81 0-43.41-18.82Q83-227.65 85-254l31-490q2-24 19.1-40 17.11-16 40.9-16h608q23.79 0 40.9 16 17.1 16 19.1 40l31 490q2 26.35-15.59 45.18Q841.81-190 816-190h-43l-11 30H198Z"
		/>
	</svg>
);
